import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ToastData } from '@shared/component/toast/toast.model';
import { ToastComponent } from '@shared/component/toast/toast.component';

import { config } from '../../shared/component/toast/toast.config';
import { ErrorBackend } from '@model/error.model';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private snackBar: MatSnackBar) {}

  show(translateKey: string = 'unexpectError', errors: string[] = [], showTimestamp: boolean = true): void {
    this.snackBar.openFromComponent(ToastComponent, {
      ...config,
      data: {
        errors,
        translateKey,
        showTimestamp
      } as ToastData
    });
  }

  showErrorToastFromBackend(error: ErrorBackend, currentLang: string): void {
    if (currentLang === 'th') {
      this.show(error.messageTh);
    } else {
      this.show(error.message);
    }
  }
}
